import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Services } from '../services-url';

@Injectable({
  providedIn: 'root'
})
export class CapitalsService {

  constructor(
    private http: HttpClient,
  ) { }

  getYears(): Observable<any> {
    return this.http.get(Services.yearsCapitls);
  }

  getDepartaments(): Observable<any> {
    return this.http.get(Services.departaments);
  }

  getIndicator(depId, year): Observable<any> {
    return this.http.get(`${Services.indicatorCapital}/${year}/${depId}`);
  }

  getIndicatorsDetails(depId, years): Observable<any> {
    return this.http.get(`${Services.indicatoCapitalDetails}/${depId}/${years[0]}/${years[1]}`);
  }
}
